import React, {
    useEffect,
    useState,
} from 'react';
import {
    Navbar,
    Nav,
    Button,
    Row,
    Col
} from 'reactstrap';
import colors from "../config/Color.config";
import DominosLogo from "../assets/images/logo/dominosLogo.png";
import GPMLogo from "../assets/images/logo/gpmLogoBlanco.png";




const NavBarDesktop = (props) => {


    const [isButtonHover, setButtonHover] = useState({
        0: false,
        1: false,
        2: false,
        3: false,
        4: false,
        5: false,
        6: false,
    });



    useEffect(() => {

    }, []);

    return (
        <>
            <div
                style={{
                    position: "fixed",
                    top: 0,
                    width: "100%",
                    zIndex: "100",
                    fontFamily: "monospace",
                    boxShadow: `1px 1px 1px 1px ${colors.azulClaro}`,
                }}
            >
                <Navbar
                    expand="md"
                    style={{
                        backgroundColor: colors.azulClaro,
                        height: "62px"
                    }}>
                    <Nav className="ml-auto" expand="md" navbar style={{ marginTop: "-5px" }}>

                        <img
                            src={DominosLogo}
                            alt="No imagen"
                            height={40}
                            style={{
                                // marginRight:"5px",
                                cursor: "pointer"
                            }}
                            onClick={() => {
                                window.location.href = "/"
                            }}
                        />

                        <Button
                            style={{
                                marginLeft: "5px",
                                backgroundColor: colors.azulClaro,
                                color: colors.blanco01,
                                boxShadow: "none",
                                fontWeight: "bold",
                                borderRadius: "0px 0px 0px 0px",
                                borderColor: isButtonHover[1] ? `transparent transparent ${colors.blanco01} transparent` : "transparent",
                                fontSize: "18px"
                            }}
                            onMouseEnter={() => {
                                setButtonHover({
                                    0: false,
                                    1: true,
                                    2: false,
                                    3: false,
                                    4: false,
                                    5: false,
                                });
                            }}
                            onMouseLeave={() => {
                                setButtonHover({
                                    0: false,
                                    1: false,
                                    2: false,
                                    3: false,
                                    4: false,
                                    5: false,
                                });
                            }}
                            onClick={() => {
                                window.location.href = "/";
                            }}
                        >

                            Inicio
                        </Button>

                        <Button
                            style={{
                                marginLeft: "5px",
                                backgroundColor: colors.azulClaro,
                                color: colors.blanco01,
                                boxShadow: "none",
                                fontWeight: "bold",
                                borderRadius: "0px 0px 0px 0px",
                                borderColor: isButtonHover[2] ? `transparent transparent ${colors.blanco01} transparent` : "transparent",
                                fontSize: "18px"
                            }}
                            onMouseEnter={() => {
                                setButtonHover({
                                    0: false,
                                    1: false,
                                    2: true,
                                    3: false,
                                    4: false,
                                    5: false,
                                });
                            }}
                            onMouseLeave={() => {
                                setButtonHover({
                                    0: false,
                                    1: false,
                                    2: false,
                                    3: false,
                                    4: false,
                                    5: false,
                                });
                            }}
                            onClick={() => {
                                window.location.href = "/unidades";
                            }}
                        >
                            Nuestras unidades
                        </Button>
                        <Button
                            style={{
                                marginLeft: "5px",
                                backgroundColor: colors.azulClaro,
                                color: colors.blanco01,
                                boxShadow: "none",
                                fontWeight: "bold",
                                borderRadius: "0px 0px 0px 0px",
                                borderColor: isButtonHover[3] ? `transparent transparent ${colors.blanco01} transparent` : "transparent",
                                fontSize: "18px"
                            }}
                            onMouseEnter={() => {
                                setButtonHover({
                                    0: false,
                                    1: false,
                                    2: false,
                                    3: true,
                                    4: false,
                                    5: false,
                                });
                            }}
                            onMouseLeave={() => {
                                setButtonHover({
                                    0: false,
                                    1: false,
                                    2: false,
                                    3: false,
                                    4: false,
                                    5: false,
                                });
                            }}
                            onClick={() => {
                                window.location.href = "https://dominoswow.mx/tyc/";
                            }}
                        >
                            Términos y Condiciones
                        </Button>



                    </Nav>
                    <Row>
                        <Col>
                            <Button
                                style={{
                                    marginLeft: "5px",
                                    backgroundColor: colors.azulClaro,
                                    color: colors.blanco01,
                                    boxShadow: "none",
                                    fontWeight: "bold",
                                    borderRadius: "0px 0px 0px 0px",
                                    borderColor: isButtonHover[0] ? `transparent transparent ${colors.blanco01} transparent` : "transparent",
                                    fontSize: "18px"
                                }}
                                onMouseEnter={() => {
                                    setButtonHover({
                                        0: true,
                                        1: false,
                                        2: false,
                                        3: false,
                                        4: false,
                                        5: false,
                                    });
                                }}
                                onMouseLeave={() => {
                                    setButtonHover({
                                        0: false,
                                        1: false,
                                        2: false,
                                        3: false,
                                        4: false,
                                        5: false,
                                    });
                                }}
                                onClick={() => {
                                    window.location.href = "/";
                                }}
                            >

                                <img
                                    src={GPMLogo}
                                    height="45px"
                                    title="Volver a la pagina de GPM"
                                    alt="No sed pudo cargar la imagen"
                                />
                            </Button>
                        </Col>
                    </Row>

                </Navbar>
            </div>
        </>
    );
}

export default NavBarDesktop;